import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AccountUserService } from 'src/app/service/account.service';

@Injectable({
  providedIn: 'root'
})
export class GoalsService {

  localAppUrl = "";
  goalForecastingApi = "";
  inventoryApi = ""
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  user: any;
  constructor(private http: HttpClient, private accountUserService: AccountUserService) {
    this.accountUserService.user.subscribe(x => this.user = x);
    this.localAppUrl = environment.localApiUrl;
    this.goalForecastingApi = environment.goalForecastingURL;
    this.inventoryApi = environment.inventoryURl;
  }


  getAllCategory(id) {
    return this.http.get<any>(this.goalForecastingApi + 'Category?OrganizationId=' + id)
      .toPromise()
      .then(res => res);
  }

  getGoalNameByObject(objectId) {
    return this.http.get<any>(this.goalForecastingApi + 'GoalPerformanceIndex?objectId=' + objectId)
      .toPromise()
      .then(res => res);
  }

  getAllTerritory(companyId, userId) {
    return this.http.get<any>(environment.territoryURL + 'Territory?OrganizationId=' + companyId + '&loginUserId=' + userId + '&objectNameList=territoryuser&PageNumber=0&PageSize=0&SortBy=CreatedDate&IsAscending=true')
      .toPromise()
      .then(res => res);
  }

  getAllGoalCategories() {
    return this.http.get<any>(environment.coreUrl + 'LionO360_Object')
      .toPromise()
      .then(res => res);
  }

  getAllProductCategory(id) {
    return this.http.get<any>(this.inventoryApi + 'Category?OrganizationId=' + id)
      .toPromise()
      .then(res => res);
  }

  getAllProduct(id) {
    return this.http.get<any>(this.inventoryApi + 'Product/GetAllProduct?OrganizationId=' + id)
      .toPromise()
      .then(res => res);
  }

  getAllGroup() {
    return this.http.get<any>(this.goalForecastingApi + 'Group')
      .toPromise()
      .then(res => res);
  }

  getAllType(id) {
    return this.http.get<any>(this.goalForecastingApi + 'Type?groupId=' + id)
      .toPromise()
      .then(res => res);
  }

  getAllStages() {
    return this.http.get<any>(this.localAppUrl + 'ContactStages/')
      .toPromise()
      .then(res => res);
  }

  getAllGoals(pageSize: number, pageNumber: number, companyID: number, userLoginID: number, dateSearch, searchValue?: string, seachFields?: string, options?, objectNamesList?) {
    let url = this.goalForecastingApi + "Goal?organizationId=" + companyID + "&loginUserId=" +
      userLoginID + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize + "&filter=" + dateSearch
    if (options) {
      if (options.sort) {
        url = `${url}&SortBy=${options.sort.SortBy}&IsAscending=${options.sort.IsAscending}`;
      }
    }
    if (!options || !options.sort) {
      url = `${url}&SortBy=createdDate&IsAscending=false`;
    }

    if (searchValue) {
      url = `${url}&SearchValue=${searchValue}&SearchColumns=${seachFields}`;
    }
    return this.http.get<any>(url, {
      observe: 'response'
    })
      .toPromise()
      .then(res =>

      ({
        goals: res.body,
        headers: JSON.parse(res.headers.get('x-pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false}
      })

      );
  }

  getGoalById(id) {
    return this.http.get<any>(this.goalForecastingApi + 'Goal/' + id)
      .toPromise()
      .then(res => res);
  }

  getDetailsById(id){
    return this.http.get<any>(this.goalForecastingApi + 'Goal/ListGoalDetails?goalId=' + id)
    .toPromise()
    .then(res => res);
  }

  getForecastingById(id, userId){
    return this.http.get<any>(this.goalForecastingApi + 'GoalForecast/GetGoalForecastsDetails?goalId=' + id +'&assignuserId='+ userId)
    .toPromise()
    .then(res => res);
  }

  assignGoal(c) {
    return this.http.post(this.goalForecastingApi + 'GoalAssignment/AssignSubLevelGoal', c)
      .toPromise()
      .then(res => res);
  }

  addGoal(c) {
    return this.http.post(this.goalForecastingApi + 'Goal', c)
      .toPromise()
      .then(res => res);
  }

  updateGoal(c) {
    return this.http.put(this.goalForecastingApi + 'Goal', c)
      .toPromise()
      .then(res => res);
  }
  deleteGoal(id){
    return this.http.delete<any>(this.goalForecastingApi + 'Goal/'+ id)
    .toPromise()
    .then(res => res);
  }
  updateUser(user) {
    return this.http.put(this.localAppUrl + 'users/' + user.id, user, { headers: this.headers })
      .toPromise()
      .then(() => user);
  }
}
